'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reseller = require('../actions/reseller');

var _withdraw_list = require('../components/withdraw_list');

var _withdraw_list2 = _interopRequireDefault(_withdraw_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WithDraws = _react2.default.createClass({
  displayName: 'WithDraws',

  propTypes: {
    withdraws: _react.PropTypes.object.isRequired,
    dispatch: _react.PropTypes.func.isRequired
  },
  componentWillMount: function componentWillMount() {
    var dispatch = this.props.dispatch;

    dispatch((0, _reseller.fetchWithDrawsData)());
  },
  onPageChange: function onPageChange(page) {
    var dispatch = this.props.dispatch;

    dispatch((0, _reseller.fetchWithDrawsData)(page));
  },
  handleStatusChange: function handleStatusChange(id) {
    var dispatch = this.props.dispatch;

    dispatch((0, _reseller.updateDataStatus)(id));
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { id: 'withDrawList', className: 'clearfix' },
      _react2.default.createElement(_withdraw_list2.default, { data: this.props.withdraws, onChange: this.onPageChange, handleStatusChange: this.handleStatusChange })
    );
  }
});

var mapStateToProps = function mapStateToProps(store) {
  var withdraws = store.reseller.withdraws;

  return {
    withdraws: withdraws
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WithDraws);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/withdraws.js
// module id = 1575
// module chunks = 0